import { FC, ReactNode, useState } from "react";
import { ProColumns } from "@ant-design/pro-table";
import { connect } from "react-redux";
import { RootState } from "reducers";
import PayeeEnterpriseDetails from "./payee-enterprise-details";
import { deleteEntity, getEntities, getEntity } from "./payee-enterprise.reducer";
import { RouteComponentProps } from "@reach/router";
import { Button, Form, Input, Popconfirm, Tooltip } from "antd";
import SearchBox from "components/search-box";
import PayeeEnterpriseEdit from "./payee-enterprise-edit";
import ListViewPage from "layouts/page-wraper/list-view-page";
import { PayeeEnterprise } from "model/system/payee-enterprise.model";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";


export interface PayeeEnterpriseListProps
  extends StateProps, DispatchProps, RouteComponentProps {
  children?: ReactNode;
}
export const columns: ProColumns<PayeeEnterprise>[] = [{
  title: '主体编码',
  dataIndex: 'code',
  valueType: 'text',
}, {
  title: '主体名称',
  dataIndex: 'name',
  valueType: 'text',
}]

const PayeeEnterpriseList: FC<PayeeEnterpriseListProps> = (props) => {

  const {deleteEntity} = props;
  const [editModal, setEditModal] = useState<any>({text: '', id: 0});
  const editPage = (params: any) => <PayeeEnterpriseEdit id={params.id} text={params.text} />;

  const searchFields = [{
    label: '主体名称',
    name: 'name.contains',
  }];

  const quickFilterPanel = (
    <Form.Item>
      <Input.Group compact>
        <SearchBox
          fields={searchFields}
        />
      </Input.Group>
    </Form.Item>
  );

  const rowActions = [(dom: ReactNode, record: any) => {
    return <Tooltip title="编辑">
      <Button type="link" onClick={() => {
        setEditModal({ id: record.code, text: String(new Date()) })
      }} icon={<EditOutlined />} />
    </Tooltip>
  }, (dom: ReactNode, record: any) => {
    return <Popconfirm
      title="确定要删除吗"
      onConfirm={() => deleteEntity(record.code)}
      okText="确定"
      cancelText="取消"
    >
      <Tooltip title="删除">
        <Button danger type="link" icon={<DeleteOutlined />} />
      </Tooltip>
    </Popconfirm>
  }];

  return (
    <ListViewPage<PayeeEnterprise>
      columns={columns}
      quickFilterPanel={quickFilterPanel}
      detailPage={<PayeeEnterpriseDetails navigate={props.navigate} columns={columns} />}
      editPage={(params: any) => <PayeeEnterpriseEdit id={params.id} text={params.text} />}
      rowActions={rowActions}
      hideEditButton
      hideDeleteButton
      {...props}
    >
      {props.children}
      {editPage(editModal)}
    </ListViewPage>
  );
};

const mapStateToProps = ({ payeeEnterprise }: RootState) => ({
  entity: payeeEnterprise.entity,
  entities: payeeEnterprise.entities,
  loading: payeeEnterprise.loading,
  updateSuccess: payeeEnterprise.updateSuccess,
  createSuccess: payeeEnterprise.createSuccess,
  total: payeeEnterprise.total
});

const mapDispatchToProps = {
  getEntity,
  getEntities,
  deleteEntity
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PayeeEnterpriseList);